/* eslint-disable */
// NewItemFields — New-DNA field body for the Originals "New Item" modal. Every
// binding is wired to its REAL source (catalog system_config.fields via getOpts;
// Brand "Other" → brandCustom + auto-SKU). Preserves materialDetail + advanced
// (SKU/location/color/price) + developmentOrder so no data capability is lost.
import React from 'react';
import DnaSelect from '../dna/DnaSelect';
import DnaSegmented from '../dna/DnaSegmented';
import { DevImageUploader } from '../../DevImageUploader';
import { MATERIAL_SUB_OPTIONS } from '../../shared';
import cf from '../devForm/createForm.module.css';
import ni from './newItem.module.css';

export default function NewItemFields({
  form, set, errs, regField, getOpts, brandOpts, onBrandChange, onBrandCustomChange,
  onMaterialChange, skuLoading, onUploadingChange,
}) {
  const materialDetailOptions = MATERIAL_SUB_OPTIONS[form.material] || [];
  return (
    <>
      {/* Frame Photos */}
      <section className={cf.section}>
        <div className={cf.sectionHead}>Frame Photos</div>
        <DevImageUploader
          images={form.images || []} onChange={(imgs) => set('images', imgs)}
          onUploadingChange={onUploadingChange} enablePaste
        />
      </section>

      {/* Item Details */}
      <section className={cf.section}>
        <div className={cf.sectionHead}>Item Details</div>
        <div className={cf.grid2}>
          {/* Brand + Other → new brand */}
          <div className={`${cf.field} ${cf.span2}`} ref={regField('brand')}>
            <DnaSelect
              label="Brand" required searchable
              options={brandOpts} value={form.brand} onChange={onBrandChange}
              error={!!errs.brand} placeholder="Search brand"
            />
            {form.brand === 'Other' && (
              <div className={ni.brandNew}>
                <label className={ni.brandNewLabel}>New brand name *</label>
                <div className={ni.brandNewRow}>
                  <span className={ni.brandNewMark}>+</span>
                  <input
                    className={`${cf.input} ${ni.brandNewInput}`}
                    value={form.brandCustom || ''} onChange={(e) => onBrandCustomChange(e.target.value)}
                    placeholder="Enter new brand name…" autoFocus
                  />
                  <span className={ni.brandNewTag}>NEW</span>
                </div>
                <div className={ni.brandNewHint}>Brand will be added to the list for all users</div>
              </div>
            )}
          </div>

          <div ref={regField('frameCategory')}>
            <DnaSegmented
              label="Optic / Sunglasses" required
              options={getOpts('frameCategory')} value={form.frameCategory}
              onChange={(v) => set('frameCategory', v)} error={!!errs.frameCategory}
            />
          </div>
          <DnaSelect label="Origin" options={getOpts('origin')} value={form.origin} onChange={(v) => set('origin', v)} placeholder="Select origin" />

          <DnaSelect
            label="Material" required options={getOpts('material')} value={form.material}
            onChange={onMaterialChange} error={!!errs.material} placeholder="Select material" fieldRef={regField('material')}
          />
          {materialDetailOptions.length > 0 ? (
            <DnaSelect label="Material Detail" options={materialDetailOptions} value={form.materialDetail} onChange={(v) => set('materialDetail', v)} placeholder="Select detail" />
          ) : <div />}

          <DnaSelect label="Gender" options={getOpts('gender')} value={form.gender} onChange={(v) => set('gender', v)} placeholder="Select gender" />
          <DnaSelect label="Shape 1" required options={getOpts('shape1')} value={form.shape1} onChange={(v) => set('shape1', v)} error={!!errs.shape1} placeholder="Select shape" fieldRef={regField('shape1')} />

          <DnaSelect label="Shape 2" options={getOpts('shape2')} value={form.shape2} onChange={(v) => set('shape2', v)} placeholder="Select shape" />
          <DnaSelect label="Shape 3" options={getOpts('shape3')} value={form.shape3} onChange={(v) => set('shape3', v)} placeholder="Select shape" />
        </div>
      </section>

      {/* Status & Intake */}
      <section className={cf.section}>
        <div className={cf.sectionHead}>Status &amp; Intake</div>
        <div className={cf.grid2}>
          <DnaSelect label="Status" required options={getOpts('status')} value={form.status} onChange={(v) => set('status', v)} error={!!errs.status} placeholder="Select status" fieldRef={regField('status')} />
          <DnaSelect label="Assigned To" options={getOpts('assignedTo')} value={form.assignedTo} onChange={(v) => set('assignedTo', v)} placeholder="Unassigned" />

          <div className={cf.field} ref={regField('receivedDate')}>
            <label className={cf.label}>Received Date<span className={cf.req}> *</span></label>
            <input
              type="month"
              className={`${cf.input} ${form.receivedDate ? cf.hasValue : ''} ${errs.receivedDate ? cf.err : ''}`}
              value={form.receivedDate || ''} onChange={(e) => set('receivedDate', e.target.value)}
            />
          </div>
          <div className={cf.field}>
            <label className={cf.label}>Development Order Ref</label>
            <input className={`${cf.input} ${form.developmentOrder ? cf.hasValue : ''}`} value={form.developmentOrder || ''} onChange={(e) => set('developmentOrder', e.target.value)} placeholder="DA / DO / DS…" />
          </div>
        </div>
      </section>

      {/* Additional (SKU auto + location/color/price) */}
      <section className={cf.section}>
        <div className={cf.sectionHead}>Additional</div>
        <div className={cf.grid2}>
          <div className={cf.field}>
            <label className={`${cf.label} ${ni.skuLabel}`}>SKU / Ref. Code<span className={ni.skuAuto}>Auto</span></label>
            <input className={`${cf.input} ${ni.skuInput}`} readOnly value={skuLoading ? 'Generating…' : (form.sku || 'Select brand first…')} />
          </div>
          <div className={cf.field}>
            <label className={cf.label}>Warehouse Location</label>
            <input className={`${cf.input} ${form.location ? cf.hasValue : ''}`} value={form.location || ''} onChange={(e) => set('location', e.target.value)} placeholder="Location" />
          </div>
          <div className={cf.field}>
            <label className={cf.label}>Color / Finish</label>
            <input className={`${cf.input} ${form.color ? cf.hasValue : ''}`} value={form.color || ''} onChange={(e) => set('color', e.target.value)} placeholder="Color" />
          </div>
          <div className={cf.field}>
            <label className={cf.label}>Price</label>
            <input className={`${cf.input} ${form.price ? cf.hasValue : ''}`} value={form.price || ''} onChange={(e) => set('price', e.target.value)} placeholder="Price" inputMode="numeric" />
          </div>
        </div>
      </section>

      {/* Notes */}
      <section className={cf.section}>
        <div className={cf.sectionHead}>Notes</div>
        <div className={cf.field}>
          <textarea className={`${cf.input} ${cf.textarea} ${form.notes ? cf.hasValue : ''}`} rows={3} value={form.notes || ''} onChange={(e) => set('notes', e.target.value)} placeholder="Any relevant notes about this item…" />
        </div>
      </section>
    </>
  );
}
